<div class="bn-search-hit">
  <button
    type="button"
    class="bn-search-hit__trigger"
    [disabled]="!canOpenChat()"
    [attr.aria-label]="rowAriaLabel()"
    (click)="onRowActivate($event)"
  >
    <div class="bn-search-hit__heading-row">
      <div class="bn-search-hit__heading">{{ fullName() }}</div>
      @if (chatActionHint(); as hint) {
        <div
          class="bn-search-hit__action-hint"
          [class.bn-search-hit__action-hint--existing]="hint.styleModifier === 'existing'"
          [class.bn-search-hit__action-hint--new]="hint.styleModifier === 'new'"
          aria-hidden="true"
          [attr.title]="hint.tooltip"
        >
          <i [class]="hint.iconClass" aria-hidden="true"></i>
          <span class="bn-search-hit__action-hint-label">{{ hint.label }}</span>
        </div>
      }
    </div>
    <dl class="bn-search-hit-kv bn-search-hit-kv--after-heading">
      @for (row of displayFieldRows(); track row.label) {
        <dt>{{ row.label }}</dt>
        <dd>
          @switch (row.kind) {
            @case ('date') {
              @if (row.value) {
                {{ row.value | date: 'MM/dd/yyyy' }}
              } @else {
                —
              }
            }
            @case ('phone') {
              @if (row.value) {
                {{ row.value | formatPrototypePhone }}
              } @else {
                —
              }
            }
            @default {
              {{ row.value ?? '—' }}
            }
          }
        </dd>
      }
    </dl>
  </button>
</div>
